import {useIntl} from "react-intl"
import {Icon, Popup, PopupProps} from "semantic-ui-react"

export const DatepickerHint = ({ position }: { position?: PopupProps["position"] }) => {
    const intl = useIntl()

    const hint = <div>
        <p>{intl.formatMessage({ id: "creator.calendar.pick" })}</p>
        <p>{intl.formatMessage({ id: "creator.calendar.year"})}</p>
    </div>

    return <Popup inverted wide="very" className="date-tooltip" trigger={<Icon name="info circle" />} position={position ?? "top center"} content={hint}/>
}